import { ReactNode } from 'react';
import styled from 'styled-components';

import { ErrorBoundary } from '../../ErrorBoundary';
import { SupplierSubscriptionPlansScope } from '../../supplier-subscription-plans/SupplierSubscriptionPlansScope';
import { GroupContextProvider } from '../hooks/GroupContextProvider';
import { useSidebar } from '../hooks/useSidebar';
import { ShortcutMenuProvider } from '../ShortcutMenu/components/ShortcutMenuProvider';
import { ShortcutMenu } from '../ShortcutMenu/ShortcutMenu';
import { Sidebar } from '../Sidebar/Sidebar';
import { SIDEBAR_WIDTH } from '../Sidebar/sidebar.constants';
import { Topbar } from '../Topbar/Topbar';
import { Box } from '../ui/Box';
import { theme } from '../ui/theme';

const Content = styled(Box).attrs({
    backgroundColor: 'background.default',
    position: 'absolute',
    top: '60px',
    minHeight: 'calc(100vh - 60px)', // Viewport without Topbar
    right: 0,
})<{ $isSidebarFixed: boolean }>`
    left: ${({ $isSidebarFixed }) => ($isSidebarFixed ? `${SIDEBAR_WIDTH}px` : '0px')};
    transition: left 0.15s ease-out;
`;

interface PageProps {
    children: ReactNode;
    fullPage?: boolean;
}

export const Page = ({ children, fullPage = false }: PageProps) => {
    const { isFixed } = useSidebar();

    return (
        <GroupContextProvider>
            <ShortcutMenuProvider>
                <ErrorBoundary>
                    <SupplierSubscriptionPlansScope>
                        <Sidebar />
                        <Topbar />
                        <Content
                            $isSidebarFixed={isFixed}
                            padding={fullPage ? 0 : 40}
                            onClick={(event) => {
                                window.Productlane?.close();
                                event.stopPropagation();
                            }}
                        >
                            <Box maxWidth={fullPage ? '100%' : theme.maxContentWidths.regular} margin="0 auto">
                                <ErrorBoundary>{children}</ErrorBoundary>
                            </Box>
                        </Content>
                        <ShortcutMenu />
                    </SupplierSubscriptionPlansScope>
                </ErrorBoundary>
            </ShortcutMenuProvider>
        </GroupContextProvider>
    );
};
